import PropTypes from "prop-types"
import React, { useEffect, useState, lazy, Suspense } from "react"

// Import scss
import "./assets/scss/theme.scss"
import "./custom.css"
import "./global.css"
import LoaderSvg from "assets/images/loader-icon.gif"
import { useSelector } from "react-redux"
import { createSelector } from "reselect"
import { Routes, Route } from "react-router-dom"
import { layoutTypes } from "./constants/layout"
// Import Routes all
import { authProtectedRoutes, publicRoutes } from "./routes"
import SweatAlert from "components/Shared/SweatAlert"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
const VerticalLayout = lazy(() => import("./components/VerticalLayout/"))
const HorizontalLayout = lazy(() => import("./components/HorizontalLayout/"))
const NonAuthLayout = lazy(() => import("./components/NonAuthLayout"))

// const SweatAlert = lazy(() => import("components/Shared/SweatAlert"))
const Spinners = lazy(() => import("components/Shared/Spinners"))

const getLayout = layoutType => {
  let Layout = VerticalLayout
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout
      break
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout
      break
    default:
      break
  }
  return Layout
}

const App = ({ router }) => {
  const selectLayoutState = state => state.Layout
  const LayoutProperties = createSelector(selectLayoutState, layout => ({
    layoutType: layout.layoutType,
  }))
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  const { layoutType } = useSelector(LayoutProperties)

  const Layout = getLayout(layoutType)
  const { isVisible, text, type } = useSelector(state => state.Alert)

  useEffect(() => {
    const splashScreenInterval = setInterval(() => {
      const navState = router.state.navigation.state
      if (navState == "idle") {
        // Hide the splash screen.
        setShowSplashScreen(false)
        clearInterval(splashScreenInterval)
      }
    }, 3000)

    // cleanup in case of component unmount
    ;() => clearInterval(splashScreenInterval)
  }, [])

  return (
    <React.Fragment>
      <>
        {/* {showSplashScreen ? (
          <Suspense fallback={<Spinners />}>
            <Spinners />
          </Suspense>
        ) : ( */}
        <Suspense fallback={<Spinners />}>
          {isVisible ? <SweatAlert text={text} type={type} /> : null}
          <Routes>
            {publicRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={<NonAuthLayout>{route.component}</NonAuthLayout>}
                key={idx}
                exact={true}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <Authmiddleware>
                    <Layout>{route.component}</Layout>
                  </Authmiddleware>
                }
                key={idx}
                exact={true}
              />
            ))}
          </Routes>{" "}
        </Suspense>
        {/* )} */}
      </>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

export default App
